import React, { memo, useEffect, useState } from "react"
import ImageCover from '../../images/star-cover.webp'
import ImageFlag from '../../images/star-flag.webp'
import './index.scss'

interface StarProps {
  avatar: string
}

function Star(props: StarProps) {
  const [info, setInfo] = useState<{
    avatar: string
  }>()

  useEffect(() => {
    setInfo({
      avatar: props.avatar
    })
  }, [props.avatar])

  return <div className="cmp-star">
    <div className="cmp-star-avatar">
      {info?.avatar && <img className="cmp-star-avatar__avatar" src={info.avatar} />}
      <img className="cmp-star-avatar__cover" src={ImageCover} />
    </div>
    <img className="cmp-star-flag" src={ImageFlag} />
  </div>
}

export default memo(Star)